<template>

 <div>
    <div class="overlay">Fixed</div>
    <div class="animated fadeIn">
      <div class="card">
        <div class="card-header">
          <span>điểm đến</span>
          <div class="card-header-actions"></div>
        </div>
        <div class="card-body">

            <b-row>
              <b-col md="12">
              Cập nhật thành công!
              </b-col>
            </b-row>
        </div>
      </div>
    </div>
 </div>
</template>

<script>


export default {
  data() {
    return {

    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      $('body').css('display','none')
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},



    async fn_initDataDefault() {},

    fn_hashUrl() {
      let rawUrl = window.location.search;
      let urlTrim = rawUrl.substr(1);

      let parameters = {};
      urlTrim.split("&").forEach(kv => {
          var eqIndex = kv.indexOf("=");
          if (eqIndex === -1)
              parameters[kv] = "";
          else
              parameters[kv.substr(0, eqIndex)] = decodeURIComponent(kv.substr(eqIndex + 1));
      });
      let pathLocation = parameters.src;
      window.top.redirectToDangKyDDAT(pathLocation);
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
